// src/widgets/WeatherMap.tsx
import React from 'react';
import { Map } from '../components/Map';
import { useTool } from '../contexts/ToolContext';
import './WeatherMapWidget.scss';

export interface Coordinates {
  lat: number;
  lng: number;
  location?: string;
  temperature?: {
    value: number;
    units: string;
  };
  wind_speed?: {
    value: number;
    units: string;
  };
}

export const DEFAULT_COORDS: Coordinates = {
  lat: 37.775593,
  lng: -122.418137,
};

interface WeatherMapProps {

}

export const WeatherMapWidget: React.FC<WeatherMapProps> = ({

}) => {

  const { weatherCoordinates, weatherMarker } = useTool()

  return (
    <div className="weather-map-widget">
      <div className="map-container">
        {weatherCoordinates && (
          <Map
            center={[weatherCoordinates.lat, weatherCoordinates.lng]}
            location={weatherCoordinates.location}
          />
        )}
      </div>
      <div className="widget-title">get_weather()</div>
      <div className="widget-info">
        {weatherMarker?.location || 'not yet retrieved'}
        {!!weatherMarker?.temperature && (
          <>
            <br />
            🌡️ {weatherMarker.temperature.value} {weatherMarker.temperature.units}
          </>
        )}
        {!!weatherMarker?.wind_speed && (
          <>
            {' '}
            🍃 {weatherMarker.wind_speed.value} {weatherMarker.wind_speed.units}
          </>
        )}
      </div>
    </div>
  );
};